"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UIElementShapeEnum = void 0;
let UIElementShapeEnum = exports.UIElementShapeEnum = /*#__PURE__*/function (UIElementShapeEnum) {
  UIElementShapeEnum["Rect"] = "rect";
  UIElementShapeEnum["Round"] = "round";
  return UIElementShapeEnum;
}({});